import React from "react";
import Feedback from "../Feedback";

export default function QSection() {
  return (
    <section className="d-flex gap-12 flex-column container align-items-center relative pt-10 pb-10 full-w">
      <Feedback />
    </section>
  );
}
